<template lang="pug">
  #home
    form(@submit.prevent='save')
      input(type='url' required v-model='original' placeholder='Enfie seu link e aperte enter')
</template>

<script>
// import axios from 'axios'
import Result from './Result'

export default {
  name: 'Home',
  components: {
    Result
  },
  data () {
    return {
      original: '',
      result: null,
      loading: false,
      hasError: false
    }
  },
  methods: {
    save () {
      this.$router.push({name: 'save', params: {url: this.original}})
    }
  }
}
</script>

<style lang="stylus" scoped>
  input
    width 100%
    font-size 1.6rem
    color grey
    border-radius .5rem
    border 1px lightgrey solid
    padding .4em .8em

    &::placeholder
      color lightgrey
</style>



// WEBPACK FOOTER //
// src/components/Home.vue